import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { NoticeInfo, readNoticeInfo } from "@/services/api/notice";
import { Modal, Table } from "antd";
import React from "react";

interface NoticeListModalProps extends InjectBaseModalProps {
  data: NoticeInfo[];
}

const NoticeListModal: React.FC<NoticeListModalProps> = React.memo(function (props) {
  const { visible, onCancel, data } = props;

  return (
    <Modal
      width={900}
      visible={visible}
      onCancel={onCancel}
      title="通知列表"
      keyboard={false}
      maskClosable={false}
      cancelButtonProps={{
        hidden: true,
      }}
      okText="知道了"
      closable={false}
      afterClose={async () => {
        const ids = data.map((it) => it.id);

        readNoticeInfo(ids);
      }}
      onOk={onCancel}
    >
      <Table
        rowKey="id"
        columns={[
          {
            title: "标题",
            dataIndex: "title",
            key: "title",
          },
          {
            title: "内容",
            dataIndex: "content",
            key: "content",
          },
          {
            title: "时间",
            dataIndex: "dateCreated",
            key: "dateCreated",
          },
        ]}
        dataSource={data}
        pagination={false}
      />
    </Modal>
  );
});

export default NoticeListModal;
